import DataType from '@opsbase/lib-datatype/DataType/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Validator from '@opsbase/lib-validator';
import useStaffCreate from '@opsbase/react-gql-hooks/staff/useStaffCreate';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import Pane from '@opsbase/web-layout/Pane';
import useNav from '@opsbase/web-nav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextField from '@opsbase/web-textfield/TextField';
import TextFieldWithEmail from '@opsbase/web-textfield/TextFieldWithEmails/TextFieldWithEmail';
import React, { useCallback, useState } from 'react';
export function StaffCreateDialog() {
    const { raise } = useNotificationActions();
    const createStaff = useStaffCreate();
    const [patch, setPatch] = useState({ title: '', email: '' });
    const { replaceTo } = useNav();
    const { addItemsToType } = useNewDataActionsContext();
    const handleCreate = useCallback(async () => {
        Validator.validate(patch);
        return raise(createStaff(patch), i18n.t('staff-created-successful'));
    }, [createStaff, patch, raise]);
    const handleChange = useCallforward(propertyName => value => {
        setPatch({ ...patch, [propertyName]: value });
    }, [patch]);
    const handleAfterCreate = useCallback(staff => {
        addItemsToType(DataType.STAFF, [staff]);
        replaceTo(Pages.STAFF_EDIT, { id: staff.id });
    }, [replaceTo, addItemsToType]);
    return (React.createElement(CreateDialog, { open: true, title: i18n.t('create-a-staff'), valid: Validator.isValid(patch), onCreate: handleCreate, afterCreate: handleAfterCreate },
        React.createElement(Pane, null,
            React.createElement(TextField, { label: i18n.t('enter-their-name'), white: true, fullWidth: true, autoFocus: true, value: patch.title, validator: Validator.schemas().title, onChange: handleChange('title') })),
        React.createElement(Pane, null,
            React.createElement(TextFieldWithEmail, { label: i18n.t('enter-their-email'), value: patch.email, onChange: handleChange('email'), fullWidth: true }))));
}
export default StaffCreateDialog;
